import "../../Stylesheets/Main.css"

import { useState } from "react";
import {Squash} from "hamburger-react";
import { useRef } from "react";
import { useClickAway}  from "react-use"

import { PageContext } from "../../App.js"

import { useContext } from "react"
import { useNavigate } from "react-router-dom"

const PageNavMobile = ({ ParallaxRef }) => {

    const [isOpen, setOpen] = useState(false)
    const ref = useRef(null)

    const {page, setPage} = useContext(PageContext)
    const navigate = useNavigate();

    useClickAway(ref, () => setOpen(false));

    return (
        <div ref={ref} className="mobile-menu-wrapper">
            <Squash toggle={setOpen} toggled={isOpen} />
            { isOpen && (
            <nav className = "main-menu-mobile">
                <a href="#" className="mobile-menu-item" onClick={() => {setPage("Start"); navigate("/")}}>
                Start
                </a>
                <hr className="mobile-menu-seperator"/>
                <a href="#" className="mobile-menu-item" onClick={() => {setPage("Service"); navigate("/")}}>
                Service
                </a>
                <hr className="mobile-menu-seperator"/>
                <a href="#" className="mobile-menu-item" onClick={() => {setPage("Produkte"); navigate("/")}}>
                Produkte
                </a>
                <hr className="mobile-menu-seperator"/>
                <a href="#" className="mobile-menu-item" onClick={() => {setPage("Kontakt"); navigate("/")}}>
                Kontakt
                </a>
            </nav>)}
        </div>
        
    );
}

export default PageNavMobile